import moment from "moment";

export default function data(data, startDate = null, endDate = null) {
  const measurements = Object.values(data || {})
    .flat()
    .filter((item) => {
      if (!startDate || !endDate) return true;
      const itemDate = moment(item.date, "DD.MM.YY");
      return itemDate.isBetween(moment(startDate), moment(endDate), "day", "[]");
    });

  const getColumns = () => {
    if (!measurements || !measurements?.length) return [];
    const item = measurements[0];
    return Object.keys(item)
      .sort()
      .reduce(
        (accum, columnName) => {
          accum.push({ Header: columnName, accessor: columnName, align: "left" });
          return accum;
        },
        [{ Header: "#", accessor: "#", width: "10%", align: "left" }]
      );
  };

  const getRows = () => {
    if (!measurements || !measurements?.length) return [];
    return measurements.reverse().reduce((accum, item, i) => {
      const row = { "#": ++i };
      Object.entries(item).forEach(([key, value]) => (row[key] = value));
      accum.push(row);
      return accum;
    }, []);
  };

  return {
    columns: getColumns(),
    rows: getRows(),
  };
}
